import cc from './cc'
import dds from './dds'
import sales from './sales'
import technical from './technical'

export default {
  cc,
  dds,
  sales,
  technical
}
